import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatRipple } from '@angular/material/core';
import { IconComponent } from '@libs/components/icons';
import { ServiceTeaserItemModel } from '@libs/cms/models';
import {
  PageBlockImpressionDirective,
  PageBlockLinkClickDirective,
  provideContentTrackingData,
} from '@libs/shared/tracking';
import { BypassSecurityPipe, ContentLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-service-teaser',
  templateUrl: './service-teaser.component.html',
  styleUrls: ['./service-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCard,
    MatRipple,
    IconComponent,
    BypassSecurityPipe,
    NgTemplateOutlet,
    ContentLinkDirective,
    PageBlockImpressionDirective,
    PageBlockLinkClickDirective,
  ],
  providers: [
    provideContentTrackingData(ServiceTeaserComponent),
  ],
})
export class ServiceTeaserComponent {
  public readonly data: InputSignal<ServiceTeaserItemModel> = input.required();
}
